import React from "react";

const NotFound = () => {
  return (
    <h4 >
      Sorry, but the page you have requested was not found.
    </h4>
  )
};

export default NotFound;